import React, { Component } from 'react'
import './styles.css'
class Col extends Component {
  render () {
    return (
      <div className={'Col Col-' + this.props.cols}>{this.props.children}</div>
    )
  }
}
export default Col
